"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLtvAndThresholdsChangeFactory = exports.calculateBorrowLimitBtcChangeFactory = exports.calculateThreshold = exports.calculateLtv = exports.getTotalAmountBtc = exports.calculateTotalBorrowedBtcChange = exports.calculateCollateralAmountBtc = exports.adjustToThreshold = exports.calculateBorrowLimit = void 0;
const monetary_js_1 = require("@interlay/monetary-js");
const big_js_1 = __importDefault(require("big.js"));
const _1 = require(".");
const calculateTotalBorrowedBtcChange = (action, currentTotalBorrowedBtc, actionAmountBtc) => {
    switch (action) {
        case "borrow":
            return currentTotalBorrowedBtc.add(actionAmountBtc);
        case "repay":
            return currentTotalBorrowedBtc.sub(actionAmountBtc);
        default:
            return currentTotalBorrowedBtc;
    }
};
exports.calculateTotalBorrowedBtcChange = calculateTotalBorrowedBtcChange;
const calculateCollateralAmountBtcChange = (action, currentCollateralAmountBtc, actionAmountBtc) => {
    switch (action) {
        case "lend":
            return currentCollateralAmountBtc.add(actionAmountBtc);
        case "withdraw":
            return currentCollateralAmountBtc.sub(actionAmountBtc);
        default:
            return currentCollateralAmountBtc;
    }
};
exports.calculateCollateralAmountBtc = calculateCollateralAmountBtcChange;
const adjustToThreshold = (amount, threshold) => amount.mul(threshold);
exports.adjustToThreshold = adjustToThreshold;
const calculateBorrowLimit = (totalBorrowedAmount, totalCollateralThresholdAdjustedAmount) => totalCollateralThresholdAdjustedAmount.sub(totalBorrowedAmount).max((0, _1.newMonetaryAmount)(0, monetary_js_1.Bitcoin));
exports.calculateBorrowLimit = calculateBorrowLimit;
const getTotalAmountBtc = (positions, loanAssets) => positions.reduce((total, { amount }) => {
    const { exchangeRate } = loanAssets[amount.currency.ticker];
    const amountBtc = exchangeRate.toBase(amount);
    return total.add(amountBtc);
}, (0, _1.newMonetaryAmount)(0, monetary_js_1.Bitcoin));
exports.getTotalAmountBtc = getTotalAmountBtc;
const calculateThreshold = (collateralAmount, thresholdAdjustedCollateralAmount) => {
    if (collateralAmount.toBig().eq(0)) {
        return (0, big_js_1.default)(0);
    }
    return thresholdAdjustedCollateralAmount.toBig().div(collateralAmount.toBig());
};
exports.calculateThreshold = calculateThreshold;
const calculateLtv = (collateralAmount, borrowedAmount) => {
    if (collateralAmount.toBig().eq(0)) {
        return (0, big_js_1.default)(0);
    }
    return borrowedAmount.toBig().div(collateralAmount.toBig());
};
exports.calculateLtv = calculateLtv;
const calculateBorrowLimitBtcChangeFactory = (loanAssets, totalBorrowedBtc, totalCollateralThresholdAdjustedCollateralBtc) => (action, amount) => {
    const { collateralThreshold, exchangeRate } = loanAssets[amount.currency.ticker];
    const amountBtc = exchangeRate.toBase(amount);
    const collateralThresholdAdjustedAmountBtc = adjustToThreshold(amountBtc, collateralThreshold);
    const newTotalBorrowedBtc = calculateTotalBorrowedBtcChange(action, totalBorrowedBtc, amountBtc);
    const newTotalCollateralThresholdAdjustedCollateralBtc = calculateCollateralAmountBtcChange(action, totalCollateralThresholdAdjustedCollateralBtc, collateralThresholdAdjustedAmountBtc);
    return calculateBorrowLimit(newTotalBorrowedBtc, newTotalCollateralThresholdAdjustedCollateralBtc);
};
exports.calculateBorrowLimitBtcChangeFactory = calculateBorrowLimitBtcChangeFactory;
const calculateLtvAndThresholdsChangeFactory = (loanAssets, totalBorrowedBtc, totalCollateralBtc, totalCollateralThresholdAdjustedCollateralBtc, totalLiquidationThresholdAdjustedCollateralBtc) => (action, amount) => {
    const { collateralThreshold, liquidationThreshold, exchangeRate } = loanAssets[amount.currency.ticker];
    const amountBtc = exchangeRate.toBase(amount);
    const collateralThresholdAdjustedAmountBtc = adjustToThreshold(amountBtc, collateralThreshold);
    const liquidationThresholdAdjustedAmountBtc = adjustToThreshold(amountBtc, liquidationThreshold);
    const newTotalBorrowedBtc = calculateTotalBorrowedBtcChange(action, totalBorrowedBtc, amountBtc);
    const newTotalCollateralBtc = calculateCollateralAmountBtcChange(action, totalCollateralBtc, amountBtc);
    const newTotalCollateralThresholdAdjustedCollateralBtc = calculateCollateralAmountBtcChange(action, totalCollateralThresholdAdjustedCollateralBtc, collateralThresholdAdjustedAmountBtc);
    const newTotalLiquidationThresholdAdjustedCollateralBtc = calculateCollateralAmountBtcChange(action, totalLiquidationThresholdAdjustedCollateralBtc, liquidationThresholdAdjustedAmountBtc);
    const ltv = calculateLtv(newTotalCollateralBtc, newTotalBorrowedBtc);
    const collateralThresholdWeightedAverage = calculateThreshold(newTotalCollateralBtc, newTotalCollateralThresholdAdjustedCollateralBtc);
    const liquidationThresholdWeightedAverage = calculateThreshold(newTotalCollateralBtc, newTotalLiquidationThresholdAdjustedCollateralBtc);
    return {
        ltv,
        collateralThresholdWeightedAverage,
        liquidationThresholdWeightedAverage,
    };
};
exports.calculateLtvAndThresholdsChangeFactory = calculateLtvAndThresholdsChangeFactory;
//# sourceMappingURL=loans.js.map